import clsx from "clsx";
import { useRealtimeStatus } from "@/lib/useRealtime";

/**
 * Kleine Status-Anzeige für die zentrale WebSocket-Verbindung.
 *
 * Grün = live verbunden, gelb (pulsierend) = verbindet/neu verbinden,
 * grau = getrennt. Bewusst dezent (nur Punkt) – per Tooltip lesbar.
 */
export function RealtimeStatusIndicator({ className }: { className?: string }) {
  const status = useRealtimeStatus();

  const meta =
    status === "open"
      ? { color: "bg-status-green", label: "Live verbunden", pulse: false }
      : status === "connecting"
        ? { color: "bg-status-orange", label: "Verbindung wird hergestellt …", pulse: true }
        : { color: "bg-label-tertiary", label: "Keine Live-Verbindung", pulse: false };

  return (
    <span
      className={clsx("inline-flex items-center", className)}
      title={meta.label}
      aria-label={meta.label}
      role="status"
    >
      <span className="relative inline-flex h-2.5 w-2.5">
        {meta.pulse ? (
          <span
            className={clsx(
              "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
              meta.color,
            )}
          />
        ) : null}
        <span className={clsx("relative inline-flex h-2.5 w-2.5 rounded-full", meta.color)} />
      </span>
    </span>
  );
}
